import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import Actions from 'Actions';
import UserActions from 'actions/UserActions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import ForgotPasswordBindings from 'analytics/bindingMethods/components/globalModals/forgotPasswordModal/ForgotPasswordBindings';
import ResetPasswordConfirmationModalEN from 'components/GlobalModals/ResetPasswordConfirmationModal/locales/ResetPasswordConfirmationModal_en_US';
import ResetPasswordConfirmationModalFR from 'components/GlobalModals/ResetPasswordConfirmationModal/locales/ResetPasswordConfirmationModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(ResetPasswordConfirmationModalEN, ResetPasswordConfirmationModalFR);

const localization = createStructuredSelector({
    emailSent: getTextFromResource(getText, 'emailSent'),
    confirmButton: getTextFromResource(getText, 'confirmButton'),
    confirmationMessage: getTextFromResource(getText, 'confirmationMessage'),
    confirmationMessage2: getTextFromResource(getText, 'confirmationMessage2'),
    didntGetEmail: getTextFromResource(getText, 'didntGetEmail'),
    resend: getTextFromResource(getText, 'resend'),
    error: getTextFromResource(getText, 'error'),
    errorMessage: getTextFromResource(getText, 'errorMessage')
});

const fields = createStructuredSelector({
    localization
});

const functions = dispatch => ({
    onDismiss: () => {
        dispatch(Actions.showResetPasswordConfirmationModal({ isOpen: false }));
    },
    forgotPassword: (login, successCallback, failureCallback, source, options) => {
        dispatch(UserActions.forgotPassword(login, successCallback, failureCallback, source, options));
    },
    emailResentTracking: ForgotPasswordBindings.emailResent
});

const withResetPasswordConfirmationModalProps = wrapHOC(connect(fields, functions));

export {
    withResetPasswordConfirmationModalProps, fields, functions
};
